module.exports = __webpack_public_path__ + "images/emoji/end.e82232b6c4c267ef641e.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/end.png
// module id = UQSL
// module chunks = 14